import { z } from 'zod'
import { peruPhone } from '../../../lib/validators'
import { useZodForm } from '@minetrace/ui/forms'

export const step1IdentitySchema = z.object({
  ruc: z.string().length(11),
  legalName: z.string().min(1),
  commercialName: z.string().optional(),
  taxAddress: z.string().optional(),
  ubigeoCode: z.string().optional(),
  mainPhone: peruPhone(),
  mainEmail: z
    .string()
    .optional()
    .refine((val) => !val || val === '' || z.string().email().safeParse(val).success, {
      message: 'Email inválido',
    }),
  website: z.string().optional(),
  prefix: z.string().max(3).optional(),
})

export type Step1IdentityFormValues = z.infer<typeof step1IdentitySchema>

const defaultValues: Step1IdentityFormValues = {
  ruc: '',
  legalName: '',
  commercialName: '',
  taxAddress: '',
  ubigeoCode: '',
  mainPhone: '',
  mainEmail: '',
  website: '',
  prefix: '',
}

export const useStep1IdentityForm = (props?: { defaultValues?: Step1IdentityFormValues; disabled?: boolean }) => {
  return useZodForm<Step1IdentityFormValues>({
    validationSchema: step1IdentitySchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
